// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2-TL-","calendarButtons":"ClockData_calendarButtons__3pMEd"};